import React from 'react';
import { faStreetView } from '@fortawesome/pro-solid-svg-icons/faStreetView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function StreetViewSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faStreetView} {...props} />;
}
